import React, { useEffect, useState } from "react";
import { getRemindersByPatient } from "apiHandler/actions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { displayDateFormatter } from "components/helpers";
import { useUserData } from "components/customHooks/userDataContext";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
} from "@mui/material";

const RemindersModal = ({ onClose, appointment }) => {
  const [data, setData] = useState([]);
  const userData = useUserData();
  const token = userData?.access_token;

  useEffect(() => {
    const fetchData = async () => {
      if (!appointment) return;
      const { practice_id, patient_id, encounter_id } = appointment;
      const payload = {
        search_criteria: {
          practice_id,
          patient_id: patient_id.toString(),
          encounter_id,
        },
      };
      const response = await getRemindersByPatient(payload, token);
      if (response) setData(response);
    };
    fetchData();
  }, [appointment]);

  return (
    <Modal onClose={onClose} open={true}>
      <div className="reminders-modal">
        <h1>Reminders</h1>
        <p className="name">
          {appointment.first_name} {appointment.last_name}
        </p>
        <div>
          {!data || !data?.length > 0 ? (
            <p>No Reminders Available</p>
          ) : (
            data.map((r, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <strong>{r.reminder_status}</strong>
                  <span>{displayDateFormatter(r.reminder_sent_date)}</span>
                  <span>{r.dos_time}</span>
                </AccordionSummary>
                <AccordionDetails>{r.reminder_sent_text}</AccordionDetails>
              </Accordion>
            ))
          )}
        </div>
      </div>
    </Modal>
  );
};

export default RemindersModal;
